<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x=".5"
      width="20"
      height="20"
      rx="4"
      fill="#000"
    />
    <path
      d="M10.496 6v8M6.5 10.003h8"
      stroke="#fff"
      stroke-width="1.5"
    />
  </svg>
</template>
